import React, { Component } from "react";
import Select from 'react-select';
import ReactExport from "react-data-export";
import moment from 'moment';
import ExportPDF from "./funds_transfer_report_pdf";
import { NotificationManager, NotificationContainer } from 'react-notifications';
import { Redirect, BrowserRouter, Route, Switch } from "react-router-dom";
import Logout from "./../../loginService/logout";
import CircularProgress from "@material-ui/core/CircularProgress";

var service = require('../service/getinfo.js');
const customStyles = service.customStyles;

const roundup = require('../service/numberService.js').roundup;
const changeFloat = require('../service/numberService.js').changeFloat;
const defaultFundAccReceiveRoundup = 'Office';

const numberWithCommas_display = require('../service/excelService.js').numberWithCommas_display;
const redFontRightAlignCell = require('../service/excelService.js').redFontRightAlignCell;
const rightAlignCell = require('../service/excelService.js').rightAlignCell;
const fontBoldCell = require('../service/excelService.js').fontBoldCell;
const boldFontRightAlignCell = require('../service/excelService.js').boldFontRightAlignCell;

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;

const backend = require('../../config.js').backend;
// const backend = config.backend;

const monthNames = require('../../config.js').params.monthNames;
const sinAdmin_display = 'Sin Admin Charges (to Office)';
const donation_display = 'Donations Directed to Office';
const budget_display = 'Fund-raising Projects';
const transfer_display = 'Transfers Summary';
const excel_1st_cell_width = 55;
const excel_2nd_cell_width = 25;
const excel_3rd_cell_width = 40;
const excel_4th_cell_width = 37;
const excel_5th_cell_width = 50;
const excel_6th_cell_width = 70;

const reportTitle = 'Funds Transfer Report';

const StartDateInput = React.forwardRef(({ value, onClick }, ref) => (
  <input
    data-testid="start-date-input"
    onClick={onClick}
    ref={ref}
    value={value}
  />
));

const EndDateInput = React.forwardRef(({ value, onClick }, ref) => (
  <input
    data-testid="end-date-input"
    onClick={onClick}
    ref={ref}
    value={value}
  />
));
class Funds_Transfer_Report extends Component {

  constructor(props) {
    super(props);

    this.state = {
      startMonthYears: [],
      endMonthYears: [],
      startMonth: '',
      endMonth: '',
      startYear: '',
      endYear: '',
      checked: false,
      errors: {},
      loading: 'true',
      isButtonDisabled: false,
      allDesigs: {},
      bankAccounts: [],
      staffid: sessionStorage.getItem('id_e'),
      staffName: sessionStorage.getItem('name'),
      staffEmail: sessionStorage.getItem('email'),
      redirectLogout: false
    }
  }

  _isMounted = false;


  componentDidMount() {
    this._isMounted = true;
    this.renderStartMonthYear();
    this.renderEndMonthYear();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  renderStartMonthYear = _ => {
    service.getFinYearList()
      .then((monthyear_drop) => {
        if (this._isMounted) {
          this.setState({ startMonthYears: monthyear_drop });
        }
      })
  }

  renderEndMonthYear = _ => {
    service.getFinYearList()
      .then((monthyear_drop) => {
        ;
        if (this._isMounted) {
          this.setState({ endMonthYears: monthyear_drop });
        }
      })
  }

  handleStartMonthYearChange = (my) => {
    var month = parseInt(my.value[0], 10) + 1;
    this.setState({ startMonth: month });
    this.setState({ startYear: my.value[1] });
  }

  handleEndMonthYearChange = (my) => {
    var month = parseInt(my.value[[0]], 10) + 1;
    this.setState({ endMonth: month });
    this.setState({ endYear: my.value[1] });
  }

  getDesigs = () => {

    fetch(backend + `api/v1/gift/alldesignames`, {
      method: 'GET',
      credentials: "include",
    })
      .then(response => response.json())
      .then((data) => {
        if (data.redirect) {
          this.setState({ redirectLogout: true })
          window.location.reload(false);
        }
        else {
          this.setState({ allDesigs: data });
        }
      })
      .catch((err) => {
        console.log('getDesigns error', err);
      });

  }

  inputValid = () => {
    let errors = {};
    let formIsValid = true;

    const { startYear } = this.state;
    const { endYear } = this.state;
    const { startMonth } = this.state;
    const { endMonth } = this.state;

    if (!(isFinite(String(endYear)) && endYear !== '')) {
      errors['end'] = 'Please select!';
      formIsValid = false;
    }

    if (!(isFinite(String(startMonth)) && startMonth !== '' && startMonth !== null)) {
      errors['start'] = 'Please select!';
      formIsValid = false;
    }

    if (startYear > endYear) {
      errors['start'] = 'Out of range!';
      formIsValid = false;
    }

    if (startYear === endYear && startMonth > endMonth) {
      errors['start'] = 'Out of range!';
      formIsValid = false;
    }

    if (startMonth > moment().format("MM") && startYear >= moment().format("YYYY")) {
      errors['start'] = 'Out of range!';
      formIsValid = false;
    }

    if (endMonth > moment().format("MM") && endYear >= moment().format("YYYY")) {
      errors['end'] = 'Out of range!';
      formIsValid = false;
    }

    this.setState({ errors: errors });
    return formIsValid;
  }

  getFundsTransfer(startDate, endDate) {

    const { staffid } = this.state;
    var that = this;

    return new Promise(function (resolve, reject) {

      var url = `api/v1/fundstransfer/` + staffid + `?start=` + startDate + `&end=` + endDate;

      fetch(backend + url, {
        method: 'GET',
        credentials: "include"
      })
        .then(response => response.json())
        .then((data) => {
          if (data.redirect) {
            that.setState({ redirectLogout: true })
            window.location.reload(false);
          }
          // else if (data.error) {
          //   reject(data);
          // }
          else {
            resolve(data);
          }
        })
        .catch((err) => {
          NotificationManager.error(`Couldn't generate report. Error: ` + err);
          reject(err);
        });

    })
  }

  getReport = _ => {

    this.setState({ isButtonDisabled: false });

    let { startYear } = this.state;
    let { endYear } = this.state;
    let { startMonth } = this.state;
    let { endMonth } = this.state;

    var startDate = moment([startYear, startMonth - 1]).format("YYYY-MM-DD");
    var endDate = moment([endYear, endMonth - 1]).format("YYYY-MM-") + moment([endYear, endMonth - 1]).daysInMonth();
    console.log(startDate);
    console.log(endDate);

    this.setState({ multiData: {} });
    this.setState({ checked: false });

    if (this.inputValid()) {

      this.setState({ checked: true });
      this.getDesigs();

      this.getFundsTransfer(startDate, endDate)
        .then((result) => {
          this.setState({ multiData: result });
        })
        .catch((err) => {
          this.setState({ checked: false });
        });

    }

  }

  renderCell = (cell, index) => {
    return <td key={index} align="right">{cell.value}</td>
  }

  renderRow = (row, index) => {
    return <tr key={index}>
      <td>{Object.keys(row)[0]}</td>
      <td align="right">${numberWithCommas_display(Object.values(row)[0])}</td>
    </tr>
  }

  renderTotalRow = (row, index) => {
    return <tr key={index}>
      <td className='name'></td>
      <td className='name' align="left">Total:</td>
      <td align='right'>${numberWithCommas_display(row.totalDonation)}</td>
      <td align='right'>${numberWithCommas_display(row.totalCredit)}</td>
      <td align='right'>${numberWithCommas_display(row.totalCheque)}</td>
      <td align="right">${numberWithCommas_display(row.totalNetDonation)}</td>
    </tr>
  }

  renderDonatoinRow = (row, index) => {
    return <tr key={index}>
      <td>{row.DesigName}</td>
      <td>{"Office"}</td>
      <td align='right'>${numberWithCommas_display(row.Donation)}</td>
      <td align='right'>${numberWithCommas_display(row.Credit)}</td>
      <td align='right'>${numberWithCommas_display(row.Cheque)}</td>
      <td align="right">${numberWithCommas_display(row.NetDonation)}</td>
    </tr>
  }

  renderFundRow = (row, index) => {
    return <tr key={index}>
      <td>{row.FundAccName}</td>
      <td>{row.BankAccName}</td>
      <td align='right'>{numberWithCommas_display(row.Per)}</td>
      <td align='right'>${numberWithCommas_display(row.Donation)}</td>
      <td align='right'>${numberWithCommas_display(row.Credit)}</td>
      <td align='right'>${numberWithCommas_display(row.Cheque)}</td>
      <td align='right'>${numberWithCommas_display(row.NetDonation)}</td>
    </tr>
  }

  calcFundTotal = (budget) => {

    var funds = budget.rows;
    var total = {
      donations: 0,
      credit: 0,
      cheque: 0,
      netdonations: 0
    }
    var totalPer = 0;

    funds.map((fund) => {
      total.donations = total.donations + fund.Donation;
      total.credit = total.credit + fund.Credit;
      total.cheque = total.cheque + fund.Cheque;
      total.netdonations = total.netdonations + fund.NetDonation;
      totalPer = roundup(totalPer + fund.Per)

      return null;
    })

    var realTotal = budget.total;

    var difference = this.isTotalDifferent(total, realTotal)

    if (difference && totalPer === 100) {  // Not percentage issue, Round up to office fund

      var assigned = false;
      total = {
        donations: 0,
        credit: 0,
        cheque: 0,
        netdonations: 0
      }

      funds.map((fund) => {

        // console.log(fund)
        if (!assigned && String(fund.FundAccName).trim().toLowerCase() === defaultFundAccReceiveRoundup.toLowerCase()) {
          fund.Credit = roundup(fund.Credit + difference.credit);
          fund.Cheque = roundup(fund.Cheque + difference.cheque);
          fund.NetDonation = fund.Donation - fund.Credit - fund.Cheque;
          assigned = true;
        }

        total.donations = total.donations + fund.Donation;
        total.credit = total.credit + fund.Credit;
        total.cheque = total.cheque + fund.Cheque;
        total.netdonations = total.netdonations + fund.NetDonation;

        return null;
      });

    }

    budget['adjustTotal'] = total;

  }

  isTotalDifferent(total, realTotal) {

    var difference = {
      credit: 0,
      cheque: 0,
      donations: 0,
      netdonations: 0
    }

    if (numberWithCommas_display(total.credit) !== numberWithCommas_display(realTotal.credit)) {
      difference.credit = roundup(changeFloat(realTotal.credit) - changeFloat(total.credit))
    }

    if (numberWithCommas_display(total.cheque) !== numberWithCommas_display(realTotal.cheque)) {
      difference.cheque = roundup(changeFloat(realTotal.cheque) - changeFloat(total.cheque))
    }

    if (numberWithCommas_display(total.donations) !== numberWithCommas_display(realTotal.donations)) {
      difference.donations = roundup(changeFloat(realTotal.donations) - changeFloat(total.donations))

    }

    if (numberWithCommas_display(total.netdonations) !== numberWithCommas_display(realTotal.netdonations)) {
      difference.netdonations = roundup(changeFloat(realTotal.netdonations) - changeFloat(total.netdonations))

    }

    return difference

  }

  generatePDFFile = (multiData, filename, display, allDesigs) => {

    // double check with user
    var answer = window.confirm("Confirm to submit this report for approval ?");

    if (answer) {

      this.setState({ isButtonDisabled: true });

      var { staffid } = this.state;
      const { startYear } = this.state;
      const { endYear } = this.state;
      const { startMonth } = this.state;
      const { endMonth } = this.state;
      const { staffName } = this.state;
      const { staffEmail } = this.state;

      let data = {
        multiData: multiData,
        filename: filename,
        display: display,
        allDesigs: allDesigs,
        startDate: moment([startYear, startMonth - 1]).format("YYYY-MM-DD"),
        endDate: moment([endYear, endMonth - 1]).format("YYYY-MM-") + moment([endYear, endMonth - 1]).daysInMonth(),
        creatorName: staffName,
        creatorEmail: staffEmail
      }

      var that = this;
      var url = `api/v1/fundstransferreport/pdf/` + staffid;

      return fetch(backend + url, {
        method: 'POST',
        credentials: "include",
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ 'report': data })
      })
        .then(response => response.json())
        .then(data => {

          if (data.redirect) {
            that.setState({ redirectLogout: true })
            window.location.reload(false);
          }
          else if (data.status === 500) {
            NotificationManager.error(`Couldn't generate report. Error: ` + data.message);
          }
          else if (data === 'OK') {
            NotificationManager.success(`Report succesfully submitted for approval!`);
          }
          else {
          }

        })
        .catch(err => {
          console.log(err);
        })

    }

  }


  renderBudgetTable = (budget) => {

    let { allDesigs } = this.state;
    var desigId = budget.sourceDesig;
    var bankName = budget.sourceBankName;
    var desigName = allDesigs[desigId];
    var adjustTotal = budget.adjustTotal;
    var planStartDate = budget.planStartDate;
    var planEndDate = budget.planEndDate;

    return (
      <div key={desigId}>
        <h5 className='source-fund'>
          <b>Source Fund:</b> {desigName}
        </h5>
        <h5 className='source-fund'>
          <b>Linked Bank Account:</b> {bankName}
        </h5>
        <h5 className='source-fund'>
          <b>Project Start Date:</b> {planStartDate}
        </h5>
        <h5 className='source-fund'>
          <b>Project End Date:</b> {planEndDate}
        </h5>
        <table className="table table-striped table-hover ">
          <tbody>
            <tr>
              <th className='name'>Account Name</th>
              <th className='name'>Transfer to Bank Account</th>
              <th className='right per'>Percentage (%)</th>
              <th className='right donation'>Donations</th>
              <th className='right credit'>Credit Card Charges</th>
              <th className='right credit'>Cheque Charges</th>
              <th className='right donation'>Net Donations</th>
            </tr>
            {budget.rows.map(this.renderFundRow)}
            <tr>
              <td className='name'></td>
              <td className='name'></td>
              <td className='per' align="right">Total:</td>
              <td className='donation' align="right">${numberWithCommas_display(adjustTotal.donations)}</td>
              <td className='credit' align="right">${numberWithCommas_display(adjustTotal.credit)}</td>
              <td className='cheque' align="right">${numberWithCommas_display(adjustTotal.cheque)}</td>
              <td className='donation' align="right">${numberWithCommas_display(adjustTotal.netdonations)}</td>
            </tr>


            {(numberWithCommas_display(adjustTotal.donations) !== numberWithCommas_display(budget.total.donations))
              || (numberWithCommas_display(adjustTotal.credit) !== numberWithCommas_display(budget.total.credit))
              || (numberWithCommas_display(adjustTotal.cheque) !== numberWithCommas_display(budget.total.cheque))
              || (numberWithCommas_display(adjustTotal.netdonations) !== numberWithCommas_display(budget.total.netdonations)) ?
              <React.Fragment>
                <tr>
                  <td className='name'></td>
                  <td className='name'></td>
                  <td className='per red' align="right">Source Fund Total:</td>
                  <td className='donation red' align="right">${numberWithCommas_display(budget.total.donations)}</td>
                  <td className='credit red' align="right">${numberWithCommas_display(budget.total.credit)}</td>
                  <td className='cheque red' align="right">${numberWithCommas_display(budget.total.cheque)}</td>
                  <td className='donation red' align="right">${numberWithCommas_display(budget.total.netdonations)}</td>
                </tr>
                <tr>
                  <td className='red' colSpan="5">* Difference only round up to the 'Office' account when the total percentage is 100%.</td>
                </tr>
              </React.Fragment>
              : null
            }
          </tbody>
        </table>
      </div>

    )

  }

  renderBankTransfers(transfers) {

    return (
      <table className="table table-striped table-hover ">
        <tbody>

          {transfers.map(this.renderTransferRow)}

        </tbody>
      </table>
    );

  }

  renderTransferRow = (transfer, index) => {
    var source = transfer.source;
    var destination = transfer.destination;
    var amount = transfer.amount;

    if (source !== destination) {
      return (
        <tr key={index}>
          <td className='total' align="left">Total amount transfer from <b>{source}</b> account to <b>{destination}</b> account:</td>
          <td className='number' align="right">${numberWithCommas_display(amount)}</td>
        </tr>
      )
    }

  }

  sinAdminDataToRowList = (objList) => {

    var rowList = [];

    for (var i = 0; i < objList.length; i++) {
      var row = []
      var obj = objList[i];

      for (var j in obj) {
        row.push(j)
        row.push(rightAlignCell(obj[j]))
      }

      rowList.push(row)

    }
    return (rowList)
  }


  donationDataToRowList = (objList) => {

    var rowList = [];
    var firstRow = [];
    const isMoney = 1

    firstRow.push(fontBoldCell('Account Name'))
    firstRow.push(fontBoldCell('Transfer to Bank Account'))
    firstRow.push(fontBoldCell('Donations'))
    firstRow.push(fontBoldCell('Credit Card Charges'))
    firstRow.push(fontBoldCell('Cheque Charges'))
    firstRow.push(fontBoldCell('Net Donations'))

    rowList.push(firstRow);

    for (var i = 0; i < objList.length; i++) {
      var row = []
      var obj = objList[i];
      row.push(obj['DesigName'])
      row.push(rightAlignCell("Office"))
      row.push(rightAlignCell(obj['Donation'], isMoney))
      row.push(rightAlignCell(obj['Credit'], isMoney))
      row.push(rightAlignCell(obj['Cheque'], isMoney))
      row.push(rightAlignCell(obj['NetDonation'], isMoney))
      rowList.push(row)

    }
    return (rowList);

  }

  donationTotalRows = (objList) => {
    var rowList = []
    var total = objList;
    var totalRow = [];
    const isMoney = 1;

    totalRow.push('')
    totalRow.push('')
    totalRow.push(rightAlignCell('Total:'))
    totalRow.push(rightAlignCell(total.totalDonation, isMoney))
    totalRow.push(rightAlignCell(total.totalCredit, isMoney))
    totalRow.push(rightAlignCell(total.totalCheque, isMoney))
    totalRow.push(rightAlignCell(total.totalNetDonation, isMoney))
    rowList.push(totalRow)
    return rowList
  }

  fundDataToRowList = (objList) => {

    var rowList = [];
    var firstRow = [];
    const isMoney = 1;

    firstRow.push(fontBoldCell('Account Name'))
    firstRow.push(fontBoldCell('Transfer to Bank Account'))
    firstRow.push(fontBoldCell('Percentage (%)'))
    firstRow.push(fontBoldCell('Donations'))
    firstRow.push(fontBoldCell('Credit Card Charges'))
    firstRow.push(fontBoldCell('Cheque Charges'))
    firstRow.push(fontBoldCell('Net Donations'))

    rowList.push(firstRow)

    for (var i = 0; i < objList.length; i++) {
      var row = []
      var obj = objList[i];
      row.push(rightAlignCell(obj['FundAccName']))
      row.push(rightAlignCell(obj['BankAccName']))
      row.push(rightAlignCell(obj['Per']))
      row.push(rightAlignCell(obj['Donation'], isMoney))
      row.push(rightAlignCell(obj['Credit'], isMoney))
      row.push(rightAlignCell(obj['Cheque'], isMoney))
      row.push(rightAlignCell(obj['NetDonation'], isMoney))
      rowList.push(row)

    }

    return (rowList);

  }

  fundTotalRows = (budget) => {
    var rowList = []
    var total = budget.adjustTotal;
    var totalRow = [];
    const isMoney = 1;

    totalRow.push('')
    totalRow.push('')
    totalRow.push(rightAlignCell('Total:'))
    totalRow.push(rightAlignCell(total.donations, isMoney))
    totalRow.push(rightAlignCell(total.credit, isMoney))
    totalRow.push(rightAlignCell(total.cheque, isMoney))
    totalRow.push(rightAlignCell(total.netdonations, isMoney))
    rowList.push(totalRow)


    if ((numberWithCommas_display(total.donations) !== numberWithCommas_display(budget.total.donations))
      || (numberWithCommas_display(total.credit) !== numberWithCommas_display(budget.total.credit))
      || (numberWithCommas_display(total.cheque) !== numberWithCommas_display(budget.total.cheque))
      || (numberWithCommas_display(total.netdonations) !== numberWithCommas_display(budget.total.netdonations))) {

      var correctTotalRow = [];
      correctTotalRow.push('')
      correctTotalRow.push('')
      correctTotalRow.push(redFontRightAlignCell('Source Fund Total:'))
      correctTotalRow.push(redFontRightAlignCell(budget.total.donations, isMoney))
      correctTotalRow.push(redFontRightAlignCell(budget.total.credit, isMoney))
      correctTotalRow.push(redFontRightAlignCell(budget.total.cheque, isMoney))
      correctTotalRow.push(redFontRightAlignCell(budget.total.netdonations, isMoney))


      rowList.push(correctTotalRow)

    }

    return rowList;

  }


  transferDataToRowList = (objList) => {

    var rowList = [];
    const isMoney = 1;

    for (var i = 0; i < objList.length; i++) {
      var row = []
      var obj = objList[i];

      if (obj['source'] !== obj['destination']) {
        row.push('Total amount transfer from ' + obj['source'] + ' account to ' + obj['destination'] + ' account:')
        row.push(rightAlignCell(obj['amount'], isMoney))
        rowList.push(row)

      }
    }
    return (rowList);

  }

  formSinAdminExcel = (sinAdmin) => {
    const isMoney = 1;

    var sinAdmin_data = this.sinAdminDataToRowList(sinAdmin.rows);
    var sinAdmin_finalRow = []
    sinAdmin_finalRow.push({
      value: 'Total', style: {
        font: { bold: true },
        alignment: { horizontal: 'right' }
      }
    })
    sinAdmin_finalRow.push(boldFontRightAlignCell(sinAdmin.total, isMoney))
    sinAdmin_data.push(sinAdmin_finalRow)

    var sinAdmin_excel = {
      columns: [
        { title: sinAdmin_display, width: { wch: excel_1st_cell_width } },
        { title: '', width: { wch: excel_2nd_cell_width } },
      ],
      data: sinAdmin_data
    }

    return sinAdmin_excel

  }

  formDonationExcel = (donation) => {

    var donation_data = this.donationDataToRowList(donation.rows);
    var donation_finalRow = this.donationTotalRows(donation.total);
    // var donation_finalRow = []
    // donation_finalRow.push({
    //   value: 'Total', style: {
    //     font: { bold: true },
    //     alignment: { horizontal: 'left' }
    //   }
    // })
    // donation_finalRow.push(boldFontRightAlignCell(donation.total, isMoney))
    donation_data.push(donation_finalRow)


    var donation_excel = {
      ySteps: 1,
      columns: [
        { title: donation_display, width: { wch: excel_1st_cell_width } },//pixels width 
        { title: '', width: { wch: excel_2nd_cell_width } },
        { title: '', width: { wch: excel_3rd_cell_width } },
        { title: '', width: { wch: excel_4th_cell_width } },
        { title: '', width: { wch: excel_5th_cell_width } },
        { title: '', width: { wch: excel_6th_cell_width } },
        { title: '', width: { wch: excel_6th_cell_width } },
      ],
      data: donation_data
    }

    return donation_excel

  }


  formBudgetsExcel = (budgets) => {

    let { allDesigs } = this.state;

    var budgets_excel = []

    for (var i = 0; i < budgets.length; i++) {


      var budget = budgets[i];
      var desigName = allDesigs[budget.sourceDesig];

      var budget_sourceFundRow = [];
      budget_sourceFundRow.push({ value: 'Source Fund:', style: { font: { bold: true } } })
      budget_sourceFundRow.push(desigName);
      budget_sourceFundRow.push('')
      budget_sourceFundRow.push('')
      budget_sourceFundRow.push('')
      budget_sourceFundRow.push('')


      var budget_bankAccRow = [];
      budget_bankAccRow.push({ value: 'Linked Bank Account:', style: { font: { bold: true } } })
      budget_bankAccRow.push(budget.sourceBankName);
      budget_bankAccRow.push('');
      budget_bankAccRow.push('');
      budget_bankAccRow.push('');
      budget_bankAccRow.push('');

      var budget_planStartRow = [];
      budget_planStartRow.push({ value: 'Project Start Date:', style: { font: { bold: true } } })
      budget_planStartRow.push(budget.planStartDate);
      budget_planStartRow.push('');
      budget_planStartRow.push('');
      budget_planStartRow.push('');
      budget_planStartRow.push('');

      var budget_planEndRow = [];
      budget_planEndRow.push({ value: 'Project End Date:', style: { font: { bold: true } } })
      budget_planEndRow.push(budget.planEndDate);
      budget_planEndRow.push('');
      budget_planEndRow.push('');
      budget_planEndRow.push('');
      budget_planEndRow.push('');

      var data = [];
      data.push(budget_sourceFundRow);
      data.push(budget_bankAccRow);
      data.push(budget_planStartRow);
      data.push(budget_planEndRow);


      var budget_total_rows = this.fundTotalRows(budget)
      var budget_row = this.fundDataToRowList(budget.rows);
      data = data.concat(budget_row)
      data = data.concat(budget_total_rows)

      var budget_excel = {
        ySteps: 1,
        columns: [
          { title: budget_display, width: { wch: excel_1st_cell_width } },
          { title: '', width: { wch: excel_2nd_cell_width } },
          { title: '', width: { wch: excel_3rd_cell_width } },
          { title: '', width: { wch: excel_4th_cell_width } },
          { title: '', width: { wch: excel_5th_cell_width } },
          { title: '', width: { wch: excel_6th_cell_width } },
          { title: '', width: { wch: excel_6th_cell_width } },
          { title: '', width: { wch: excel_6th_cell_width } },
        ],
        data: data
      }

      budgets_excel.push(budget_excel);

    }

    return budgets_excel

  }


  formTransferExcel = (transfers) => {

    var transfers_data = this.transferDataToRowList(transfers);

    var transfers_excel = {
      ySteps: 1,
      columns: [
        { title: transfer_display, width: { wch: excel_1st_cell_width } },//pixels width 
        { title: '', width: { wch: excel_2nd_cell_width } }
      ],
      data: transfers_data
    }

    return transfers_excel

  }

  generateTitle(filename) {
    // title and month will have its own function
    var title = {
      ySteps: -1,
      xSteps: 2,
      columns: [
      ],
      data: [
        [

          {
            value: filename,
            style: {
              font: {
                sz: '18',
                bold: true
              },
              alignment: {
                horizontal: 'center',
                vertical: 'center',
                readingOrder: 4
              }
            }
          }

        ]

      ]
    }
    return title;
  }

  renderOfficeTable = (donation) => {
    var desigId = donation.DesigID;

    return (
      <div key={desigId}>
        <table className="table table-striped table-hover ">
          <tbody>
            <tr>
              <th className='name'>Account Name</th>
              <th className='name'>Transfer to Bank Account</th>
              <th className='right donation'>Donations</th>
              <th className='right donation'>Credit Card Charges</th>
              <th className='right donation'>Cheque Charges</th>
              <th className='right donation'>Net Donations</th>
            </tr>
             {donation.rows.map(this.renderDonatoinRow)}
             {this.renderTotalRow(donation.total)}
             </tbody>
             </table>
             </div>
    )
             {/* <tr>
    {/* //           <td className='name'></td>
    //           <td className='name'></td>
    //           <td className='per' align="right">Total:</td>
    //           <td className='donation' align="right">${numberWithCommas_display(adjustTotal.donations)}</td>
    //           <td className='credit' align="right">${numberWithCommas_display(adjustTotal.credit)}</td>
    //           <td className='cheque' align="right">${numberWithCommas_display(adjustTotal.cheque)}</td>
    //           <td className='donation' align="right">${numberWithCommas_display(adjustTotal.netdonations)}</td>
    //         </tr>


    //         {(numberWithCommas_display(adjustTotal.donations) !== numberWithCommas_display(budget.total.donations))
    //           || (numberWithCommas_display(adjustTotal.credit) !== numberWithCommas_display(budget.total.credit))
    //           || (numberWithCommas_display(adjustTotal.cheque) !== numberWithCommas_display(budget.total.cheque))
    //           || (numberWithCommas_display(adjustTotal.netdonations) !== numberWithCommas_display(budget.total.netdonations)) ?
    //           <React.Fragment>
    //             <tr>
    //               <td className='name'></td>
    //               <td className='name'></td>
    //               <td className='per red' align="right">Source Fund Total:</td>
    //               <td className='donation red' align="right">${numberWithCommas_display(budget.total.donations)}</td>
    //               <td className='credit red' align="right">${numberWithCommas_display(budget.total.credit)}</td>
    //               <td className='cheque red' align="right">${numberWithCommas_display(budget.total.cheque)}</td>
    //               <td className='donation red' align="right">${numberWithCommas_display(budget.total.netdonations)}</td>
    //             </tr>
    //             <tr>
    //               <td className='red' colSpan="5">* Difference only round up to the 'Office' account when the total percentage is 100%.</td>
    //             </tr>
    //           </React.Fragment>
    //           : null
    //         }
    //       </tbody>
    //     </table>
    //   </div>

    // ) */}

  }


  generateDate() {
    var date = moment().format('DD/MM/YYYY hh:mm:ss A');
    var datedetail = {
      ySteps: -2,
      xSteps: 6,
      columns: [],
      data: [
        [date]
      ]
    }
    return datedetail;
  }

  excelData = (data, filename) => {
    const sinAdmin = data.sinAdmin;
    const donation = data.donation;
    const budgets = data.budgets;
    const transfers = data.transfers;

    var sinAdmin_excel;
    var donation_excel;
    var budgets_excel;
    var transfers_excel;

    const title = this.generateTitle(filename);
    const date = this.generateDate();

    if (sinAdmin) {
      sinAdmin_excel = this.formSinAdminExcel(sinAdmin)
    }
    else {
      sinAdmin_excel = {
        columns: [
          { title: sinAdmin_display, width: { wch: excel_1st_cell_width } },
          { title: '', width: { wch: excel_2nd_cell_width } }
        ],
        data: []
      }
    }

    if (donation) {
      donation_excel = this.formDonationExcel(donation)
    }
    else {
      donation_excel = {
        ySteps: 1,
        columns: [
          { title: donation_display, width: { wch: excel_1st_cell_width } },
          { title: '', width: { wch: excel_2nd_cell_width } },
          { title: '', width: { wch: excel_3rd_cell_width } },
          { title: '', width: { wch: excel_4th_cell_width } },
          { title: '', width: { wch: excel_5th_cell_width } },
          { title: '', width: { wch: excel_6th_cell_width } }
        ],
        data: []
      }
    }

    if (budgets) {
      budgets_excel = this.formBudgetsExcel(budgets)
    }
    else {
      budgets_excel = {
        ySteps: 1,
        columns: [
          { title: budget_display, width: { wch: excel_1st_cell_width } },
          { title: '', width: { wch: excel_2nd_cell_width } },
          { title: '', width: { wch: excel_3rd_cell_width } },
          { title: '', width: { wch: excel_4th_cell_width } },
          { title: '', width: { wch: excel_5th_cell_width } },
          { title: '', width: { wch: excel_6th_cell_width } },
          { title: '', width: { wch: excel_6th_cell_width } }
        ],
        data: []
      }
    }

    if (transfers) {
      transfers_excel = this.formTransferExcel(transfers)
    }
    else {
      transfers_excel = {
        ySteps: 1,
        columns: [
          { title: transfer_display, width: { wch: excel_1st_cell_width } },
          { title: '', width: { wch: excel_2nd_cell_width } }
        ],
        data: []
      }
    }

    var excel_data = [title, date, sinAdmin_excel, donation_excel]
    excel_data = excel_data.concat(budgets_excel)
    excel_data.push(transfers_excel)

    return excel_data

  }

  renderReport() {
    const { multiData } = this.state;
    let checked = this.state.checked;
    const { isButtonDisabled } = this.state;

    if (checked) {

      if (multiData && Object.keys(multiData).length) {

        var sinAdmin = multiData.sinAdmin;
        var donation = multiData.donation;
        // console.log("donationssss", donation)
        var budgets = multiData.budgets;
        var transfers = multiData.transfers;
        if (budgets) {
          budgets.map(this.calcFundTotal);
        }

        const { startYear } = this.state;
        const { endYear } = this.state;
        const { startMonth } = this.state;
        const { endMonth } = this.state;

        const startMonthName = monthNames[startMonth - 1]
        const endMonthName = monthNames[endMonth - 1]
        const filename = reportTitle + ' ' + startMonthName + ' ' + startYear + ' to ' + endMonthName + ' ' + endYear;
        const excel_data = this.excelData(multiData, filename);

        var display = {
          sinAdmin: sinAdmin_display,
          donation: donation_display,
          budgets: budget_display,
          transfers: transfer_display
        }

        return (
          <div>

            <ExcelFile element={<button className="btn btn-primary">Download Excel</button>} filename={filename}>
              <ExcelSheet dataSet={excel_data} name="Report" />
            </ExcelFile>

            <div className="divider" />

            <ExportPDF data={multiData} filename={filename} display={display} allDesigs={this.state.allDesigs} />

            {(isButtonDisabled) ?
              <button type="button" className="btn btn-primary submit pull-right" disabled>Submited For Approval!</button>
              :
              <button type="button" className="btn btn-primary submit pull-right" onClick={() => this.generatePDFFile(multiData, filename, display, this.state.allDesigs)}>Submit For Approval</button>
            }

            <div className="table-container">

              <div className='sin-admin-charge'>
                <h4 className='sub-title'>
                  {sinAdmin_display}
                </h4>

                {(sinAdmin) ?

                  <table className="table table-striped table-hover">
                    <tbody>
                      {sinAdmin.rows.map(this.renderRow)}
                      <tr>
                        <td className='total' align="right">Total:</td>
                        <td className='number' align="right">${numberWithCommas_display(sinAdmin.total)}</td>
                      </tr>
                    </tbody>
                  </table>
                  :
                  <h5>No Record Found</h5>

                }

              </div>


              <div className='office-acc'>
                <h4 className='sub-title'>
                  {donation_display}
                </h4>
                {(donation) ?
                    <div>
                      {this.renderOfficeTable(donation)}
                    </div>
                  :
                  <h5>No Record Found</h5>
                }
              </div>


              <div className='budget-plan'>
                <h4 className='sub-title'>
                  {budget_display}
                </h4>
                {(budgets) ?
                  <div>
                    {budgets.map(this.renderBudgetTable)}
                  </div>
                  :
                  <h5>No Record Found</h5>
                }
              </div>

              <div className='funds-transfer'>
                <h4 className='sub-title'>
                  {transfer_display}
                </h4>
                {(transfers) ?
                  <div>
                    {this.renderBankTransfers(transfers)}
                  </div>
                  :
                  <h5>No Record Found</h5>
                }
              </div>

            </div>
          </div>);
      }
      else {
        return (
          <div style={{display:"flex", alignItems: "center", justifyContent: "center"}}>
            <h4 className='title'>Loading... This may take a while... </h4>
            <CircularProgress/>
          </div>)
      }

    }
  }


  render() {

    const { redirectLogout } = this.state;

    if (redirectLogout) {
      return (
        <BrowserRouter>
          <Switch>
            <Route exact path="/logout" component={Logout} />
            <Redirect to="/logout" />
          </Switch>
        </BrowserRouter>
      )
    }

    const { endMonthYears } = this.state;
    const { startMonthYears } = this.state;
    let report_table = this.renderReport();

    return (<div className="funds-transfer-report">
      <h3 className="title">Funds Transfer Report</h3>
      <div className="form-set row">
        <form className="form-horizontal">
          <div className="form-sets col-sm-12">
            <fieldset>
              <div className="fieldset">

                <div className="buttons col-sm-4">
                  <div className="btn-group" data-testid="start-date-input">
                    <Select className='react-select-container' styles={customStyles} options={startMonthYears} isSearchable="false" placeholder="start" onChange={this.handleStartMonthYearChange} />
                    <span className="error">{this.state.errors["start"]}</span>
                  </div>
                </div>

                <div className="buttons col-sm-4">
                  <div className="btn-group" data-testid="end-date-input">
                    <Select className='react-select-container' styles={customStyles} options={endMonthYears} isSearchable="false" placeholder="end" onChange={this.handleEndMonthYearChange} />
                    <span className="error">{this.state.errors["end"]}</span>
                  </div>
                </div>

                <div className="col-sm-4 check-button">
                  <button type="button" className="btn btn-primary submit" onClick={this.getReport}>CHECK</button>
                </div>

              </div>
            </fieldset>
          </div>
        </form>
      </div>

      <div className="report-table" id="funds-transfer-table">
        {report_table}
      </div>
      <NotificationContainer />

    </div>);

  }

}


export default Funds_Transfer_Report;
